import Vue from 'vue'
import VueResource from 'vue-resource'
import { container } from '../services/container'
import { CachedApi } from './CachedApi'

Vue.use(VueResource)

export class RecipeApi {
	constructor () {
		this.url = process.env.VUE_APP_API_URL
		this.access_token = container.get('services.oauth').getToken()
	}

	/**
	 * Get current menu
	 *
	 * @param {mixed} key
	 *
	 * @return {Promise}
	 */
	recipe (id) {
		let c = new CachedApi();


		return c.get(this.url + '/recipe/' + id, {params: {}, headers: { Authorization: 'Bearer ' + this.access_token }})
	}
};
